import React, {Component} from "react";
import {change, Field, reduxForm} from "redux-form";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {FormattedMessage} from "react-intl";
import Select from 'react-select';

// @mui/material components
import {Switch} from "@mui/material";

// core components
import Input from "components/input/input";
import GridContainer from "components/grid/gridContainer";
import GridItem from "components/grid/gridItem";
import ActionsContainer from "components/form/ActionsContainer";
import CancelButton from "../components/CancelButton";
import SubmitButton from "../components/SubmitButton";

// styles
import formStyle from "assets/jss/views/feed/formStyle";
import {withStyles} from "@mui/styles";

// utils
import {DisableVariationsFeedOptions} from "utils/DisableVariationsFeedOptions";
import {FeedType} from "utils/FeedType";
import NextFeed from "../../../../../components/feed/NextFeed";
import FeedMasterFields from "../components/FeedMasterFields";

class Form extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            enclosure: null,
            separator: null,
            recurrenceUnit: null,
            recurrenceChecked: false,
            sftpListChecked: false,
            sftpAllFiles: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if((this.props.initialValues === null && nextProps.initialValues !== null) && nextProps.initialValues.recurrence > 0) {
            this.setState({recurrenceChecked: true});
        }

        if((this.props.initialValues === null && nextProps.initialValues !== null) && nextProps.initialValues.configuration && nextProps.initialValues.configuration.fileList === true) {
            this.setState({sftpListChecked: true});
        }

        if((this.props.initialValues === null && nextProps.initialValues !== null) && nextProps.initialValues.configuration && nextProps.initialValues.configuration.hasToProcessAllFiles === true) {
            this.setState({sftpAllFiles: true});
        }
    }

    renderField = data => {
        const {classes} = this.props;
        const filedName = data.input.name;

        return (
            <div className={classes.fieldContainer}>
                <label
                    htmlFor={`csvLocalFeed_${data.input.name}`}
                    className={classes.fieldLabel}
                >
                    {data.label}
                </label>
                {data.type === "checkbox" &&
                <input
                    {...data.input}
                    type={data.type}
                    step={data.step}
                    required={data.required}
                    placeholder={data.placeholder}
                    id={`ftpFeed_${data.input.name}`}
                    className={classes.fieldFloatRight}
                    checked={data.input.value}
                />
                }
                {(data.options && data.type === "select") &&
                <Select
                    id={`ftpFeed_${data.name}_select`}
                    name={`${data.name}_select`}
                    options={data.options}
                    defaultValue={data.defaultValue}
                    value={data.options.find(option => option.value === data.input.value)}
                    onChange={(value) => {
                        this.props.dispatch(change("ftpFeed", data.input.name, value.value));
                        this.setState({[data.input.name]: value});
                    }}
                    onBlurResetsInput={false}
                />
                }
                {(data.type === 'radio' && (
                    <input
                        type={data.type}
                        id={`ftpFeed${data.input.name}`}
                        {...data.input}
                    />
                ))}
                {(data.type !== "select" && data.type !== "checkbox" && data.type !== 'radio') &&
                <Input
                    {...data.input}
                    type={data.type}
                    step={data.step}
                    required={data.required}
                    id={`ftpFeed_${data.input.name}`}
                    inputRootCustomClasses={classes.input}
                    inputProps={{
                        placeholder: data.placeholder,
                        type: data.type,
                        required: data.required,
                        ...data.input,
                        autoComplete: data.autoComplete
                    }}
                    formControlProps={{
                        className: classes.formControl
                    }}
                />
                }

                {this.props.createError && this.props.createError.errors && this.props.createError.errors[filedName] && <span className={classes.errorMessages}><FormattedMessage id={this.props.createError.errors[filedName]}/></span>}
                {this.props.updateError && this.props.updateError.errors && this.props.updateError.errors[filedName] && <span className={classes.errorMessages}><FormattedMessage id={this.props.updateError.errors[filedName]}/></span>}
            </div>
        );
    };

    handleSubmit = (e) => {
        const {fields} = this.props;

        e.preventDefault();

        if (fields.values && this.state.recurrenceChecked === false) {
            fields.values.recurrence = 0;
            fields.values.recurrenceUnit = "min";
        }

        if (fields.values && this.state.sftpListChecked === true) {
            fields.values.configuration['fileList'] = true;
        }

        if (fields.values && this.state.sftpAllFiles === true) {
            fields.values.configuration['hasToProcessAllFiles'] = true;
        }

        this.props.handleSubmit();
    };

    render() {
        const {classes, isCreating} = this.props;
        const parse = value => (value === "" || value < 0) ? 0 : parseInt(value);

        return (
            <form onSubmit={this.handleSubmit}>
                <GridContainer className={this.props.classes.formContainer}>
                    <GridItem xs={12} sm={6}>
                        <Field
                            component={this.renderField}
                            name={"name"}
                            label={<FormattedMessage id={"feed.form.label.name"}/>}
                            type={"text"}
                            required
                        />
                        <Field
                            component={this.renderField}
                            name={"configuration['host']"}
                            label={<FormattedMessage id={"feed.form.label.ftpHost"}/>}
                            type={"text"}
                            required
                        />
                        <Field
                            component={this.renderField}
                            name={"configuration['port']"}
                            label={<FormattedMessage id={"feed.form.label.ftpPort"}/>}
                            type={"number"}
                            parse={parse}
                            required
                        />
                        <Field
                            component={this.renderField}
                            name={"configuration['username']"}
                            label={<FormattedMessage id={"feed.form.label.ftpIdentifiant"}/>}
                            type={"text"}
                            required
                        />
                        <Field
                            component={this.renderField}
                            name={"configuration['password']"}
                            label={<FormattedMessage id={"feed.form.label.ftpPassword"}/>}
                            type={"password"}
                            required={isCreating}
                            placeholder={!isCreating ? '••••••••' : null}
                        />
                        <Field
                            component={this.renderField}
                            name={"configuration['folder']"}
                            label={<FormattedMessage id={"feed.form.label.folder"}/>}
                            type={"text"}
                            required
                        />
                        {!this.state.sftpListChecked &&
                            <>
                                <Field
                                    component={this.renderField}
                                    name={"configuration['mainFileNameFormula']"}
                                    label={<FormattedMessage id={"feed.form.label.mainFileNameFormula"}/>}
                                    type={"text"}
                                />
                                <Field
                                    component={this.renderField}
                                    name={"configuration['stockFileNameFormula']"}
                                    label={<FormattedMessage id={"feed.form.label.stockFileNameFormula"}/>}
                                    type={"text"}
                                />
                            </>
                        }
                        <Field
                            type={"select"}
                            component={this.renderField}
                            options={[{"label":",", "value":","}, {"label":";", "value":";"}, {"label":"|", "value":"|"}, {"label":"Tabulation", "value":"\t"}]}
                            name={"configuration['separator']"}
                            label={<FormattedMessage id={"feed.form.label.separator"}/>}
                            selected={this.props.separator ? this.props.separator : {"label":",", "value":","}}
                            required
                        />
                        <Field
                            type={"select"}
                            component={this.renderField}
                            options={[{"label":"'", "value":"'"}, {"label":"\"", "value":"\""}, {"label":"|", "value":"|"}]}
                            name={"configuration['enclosure']"}
                            label={<FormattedMessage id={"feed.form.label.enclosure"}/>}
                            selected={this.props.enclosure ? this.props.enclosure : {"label":"\"", "value":"\""}}
                            required
                        />
                    </GridItem>
                    <GridItem xs={12} sm={6}>
                        {!this.state.sftpListChecked &&
                            <>
                                <Field
                                    component={this.renderField}
                                    name={"configuration['picturesFilePath']"}
                                    label={<FormattedMessage id={"feed.form.label.picturesFilePath"}/>}
                                    type={"text"}
                                />
                                <Field
                                    component={this.renderField}
                                    name={"configuration['picturesNameFormula']"}
                                    label={<FormattedMessage id={"feed.form.label.picturesNameFormula"}/>}
                                    type={"text"}
                                />
                            </>
                        }
                        <Field
                            name="disableVariationsNotSeen"
                            component={this.renderField}
                            type="radio"
                            value={DisableVariationsFeedOptions.ALL}
                            label={<FormattedMessage id={"feed.form.label.disable.not.seen.all.feeds"} />}
                        />
                        <Field
                            name="disableVariationsNotSeen"
                            component={this.renderField}
                            type="radio"
                            value={DisableVariationsFeedOptions.THIS}
                            label={<FormattedMessage id={"feed.form.label.disable.not.seen.this.feed"} />}
                        />
                        <Field
                            name="disableVariationsNotSeen"
                            component={this.renderField}
                            type="radio"
                            value={DisableVariationsFeedOptions.NONE}
                            label={<FormattedMessage id={"feed.form.label.disable.not.seen.none"}/>}
                        />
                        <Field
                            type={"select"}
                            component={this.renderField}
                            defaultValue={{"label": <FormattedMessage id={`feed.form.label.type.${FeedType.MERCH}`} />, "value": FeedType.MERCH}}
                            options={[
                                {"label": <FormattedMessage id={`feed.form.label.type.${FeedType.MERCH}`} />, "value":FeedType.MERCH},
                                {"label": <FormattedMessage id={`feed.form.label.type.${FeedType.STOCK}`} />, "value": FeedType.STOCK},
                                {"label": <FormattedMessage id={`feed.form.label.type.${FeedType.ENRICHMENT}`} />, "value": FeedType.ENRICHMENT}
                            ]}
                            name={"type"}
                            label={<FormattedMessage id={"feed.form.label.type"}/>}
                            required
                        />
                        {this.props.retailer &&
                            <NextFeed
                                retailerId={this.props.retailer.id}
                                formName={'ftpFeed'}
                                className={classes}
                                onChange={(value) => {
                                    this.props.dispatch(change("ftpFeed", 'nextFeed', value.value));
                                    this.setState({['nextFeed']: value});
                                }}
                                actualNextFeed={this.props.initialValues && this.props.initialValues.nextFeed}
                                actualFeed={this.props.initialValues && this.props.initialValues['@id']}
                            />
                        }
                        <div className={classes.fieldContainer}>
                            <FeedMasterFields
                                feedMasterFields={this.props.initialValues?.feedMasterFields}
                                actualFeed={this.props.initialValues && this.props.initialValues['@id']}
                                onChange={(value) => {
                                    this.props.dispatch(change("ftpFeed", 'feedMasterFields', value))
                                }}
                            />
                        </div>
                        <Field
                            component={this.renderField}
                            name={"configuration['noHeaderCSV']"}
                            label={<FormattedMessage id={"feed.form.label.no.header"}/>}
                            type={"checkbox"}
                        />
                        <Field
                            component={this.renderField}
                            type={"checkbox"}
                            name={"disableUTF8Conversion"}
                            label={<FormattedMessage id={"feed.form.label.disableUTF8Conversion"} />}
                        />
                        <div className={classes.recurrence}>
                            <label className={classes.fieldLabel}>
                                <FormattedMessage id={"feed.form.label.recurrence"}/>
                            </label>
                            <Switch
                                checked={this.state.recurrenceChecked}
                                onChange={() => this.setState({recurrenceChecked: !this.state.recurrenceChecked})}
                                color="primary"
                            />
                        </div>
                        {this.state.recurrenceChecked &&
                        <div>
                            <Field
                                component={this.renderField}
                                name={"recurrence"}
                                type={"number"}
                                parse={parse}
                                required
                            />
                            <Field
                                type={"select"}
                                component={this.renderField}
                                options={[
                                    {"label":<FormattedMessage id={"feed.form.label.recurrenceUnit.min"}/>, "value":"min"},
                                    {"label":<FormattedMessage id={"feed.form.label.recurrenceUnit.hour"}/>, "value":"hour"},
                                    {"label":<FormattedMessage id={"feed.form.label.recurrenceUnit.day"}/>, "value":"day"}]}
                                name={"recurrenceUnit"}
                                label={<FormattedMessage id={"feed.form.label.recurrenceUnit"}/>}
                                selected={
                                    this.props.recurrenceUnit ?
                                        {"label": <FormattedMessage id={"feed.form.label.recurrenceUnit." + this.props.recurrenceUnit.label}/>, "value": this.props.recurrenceUnit.value} :
                                        {"label":<FormattedMessage id={"feed.form.label.recurrenceUnit.min"}/>, "value":"min"}
                                }
                                required
                            />
                        </div>
                        }
                        <div className={classes.recurrence}>
                            <label className={classes.fieldLabel}>
                                <FormattedMessage id={"feed.form.label.sftp.list"}/>
                            </label>
                            <Switch
                                checked={this.state.sftpListChecked}
                                onChange={() => this.setState({sftpListChecked: !this.state.sftpListChecked})}
                                color="primary"
                                name={"configuration[fileList]"}
                            />
                        </div>
                        {this.state.sftpListChecked ?
                            <span className={classes.fileListHelper}>
                                <FormattedMessage id={"feed.form.label.sftp.list.description"}/>
                            </span>
                            :
                            <div className={classes.recurrence}>
                                <label className={classes.fieldLabel}>
                                    <FormattedMessage id={"feed.form.label.sftp.list.all"}/>
                                </label>
                                <Switch
                                    checked={this.state.sftpAllFiles}
                                    onChange={() => this.setState({sftpAllFiles: !this.state.sftpAllFiles})}
                                    color="primary"
                                    name={"configuration[hasToProcessAllFiles]"}
                                />
                            </div>
                        }
                        <div>
                            <Field
                                component={this.renderField}
                                label={<FormattedMessage id={"feed.form.label.skipRule"} />}
                                name={"skipRule"}
                                type={"text"}
                            />
                        </div>
                    </GridItem>
                </GridContainer>
                <ActionsContainer>
                    <CancelButton retailerId={this.props.retailer && this.props.retailer['@id']} />
                    <SubmitButton loading={this.props.createLoading || this.props.updateLoading} />
                </ActionsContainer>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        createLoading:state.feed.create.loading,
        createError: state.feed.create.error,
        updateLoading: state.feed.update.updateLoading,
        updateError: state.feed.update.updateError,
        fields: state.form.ftpFeed,
        retailer: state.retailer.show.retrieved
    };
};

export default reduxForm({
    form: "ftpFeed",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
}, mapStateToProps)(connect(
    mapStateToProps,
    null
)(withStyles(formStyle)(Form)));
